<template>
  <div class="card purple">
    <div class="content">
      <div class="header">
        {{ $t('KEYBOARD') }}
        <i class="right floated outline keyboard icon"></i>
      </div>

      <div
        class="meta"
        v-if="trigger.configuration.mode == 'lookback' || !trigger.configuration.mode"
      >
        {{
          $t('KEYBOARD_META_LOOKBACK', {
            match: trigger.configuration.match,
            lookbackMs: trigger.configuration.lookbackMs || 0
          })
        }}
      </div>
      <div class="meta" v-if="trigger.configuration.mode == 'debounce'">
        {{
          $t('KEYBOARD_META_DEBOUNCE', {
            match: trigger.configuration.match,
            debounceMs: trigger.configuration.debounceMs || 0
          })
        }}
      </div>
    </div>

    <div class="primary content">
      <div class="ui tiny negative message" v-if="errorMessage">
        <i class="bullhorn icon"></i>
        {{ errorMessage }}
      </div>

      <form>
        <!-- The radio button group should not extend to neighboring keyboard triggers -->
        <regex-field
          v-model="trigger.configuration.match"
          :labelText="$t('KEYBOARD_MATCH')"
          :placeholder="$t('KEYBOARD_MATCH_PLACEHOLDER')"
          @click="$v.trigger.configuration.match.$touch()"
          :class="{ error: $v.trigger.configuration.match.$invalid }"
        />

        <div class="field" v-if="!disallowDebounceFeature">
          <!-- MODE -->
          <label>{{ $tc('KEYBOARD_MATCH_MODE', 1) }}</label>
          <div class="field">
            <div class="ui radio checkbox">
              <input
                type="radio"
                class="hidden"
                :id="'debounceMode-' + triggerIndex"
                value="debounce"
                v-model="trigger.configuration.mode"
              />
              <label :for="'debounceMode-' + triggerIndex">
                {{ $tc('KEYBOARD_MATCH_DEBOUNCE_MODE', 1) }}
              </label>
            </div>
          </div>
          <div class="field">
            <div class="ui radio checkbox">
              <input
                type="radio"
                class="hidden"
                :id="'lookbackMode-' + triggerIndex"
                value="lookback"
                v-model="trigger.configuration.mode"
              />
              <label :for="'lookbackMode-' + triggerIndex">
                {{ $tc('KEYBOARD_MATCH_LOOKBACK_MODE', 1) }}
              </label>
            </div>
          </div>
        </div>

        <div
          class="field"
          v-if="trigger.configuration.mode == 'lookback' || !trigger.configuration.mode"
          :class="{ error: $v.trigger.configuration.lookbackMs.$invalid }"
        >
          <!-- LOOKBACK MS -->
          <label for="lookbackMs">{{ $t('KEYBOARD_LOOKBACKMS') }}</label>
          <input
            id="lookbackMs"
            type="number"
            min="10"
            v-model.number="trigger.configuration.lookbackMs"
          />
        </div>

        <div
          class="field"
          v-if="trigger.configuration.mode == 'debounce'"
          :class="{ error: $v.trigger.configuration.debounceMs.$invalid }"
        >
          <!-- DEBOUNCE MS -->
          <label for="debounceMs">{{ $t('KEYBOARD_DEBOUNCEMS') }}</label>
          <input
            id="debounceMs"
            type="number"
            min="10"
            v-model.number="trigger.configuration.debounceMs"
          />
        </div>
      </form>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import _ from 'lodash'
import { Hotkey, Flow } from 'services'
import { Typeahead, RegexField } from 'ui'
import { map } from 'rxjs/operators'
import { required } from 'vuelidate/lib/validators'
import Conf from '../../../../services/conf'

function timeValidator(modeName, minValue) {
  return (value, vm) => {
    return vm.mode !== modeName || vm[modeName + 'Ms'] >= minValue
  }
}

export default {
  name: 'keyboardtrigger',
  components: { RegexField },

  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {}
        }
      }
    },
    triggerIndex: Number
  },

  data() {
    return {
      errorMessage: null,
      disallowDebounceFeature: Conf.disallowKeyboardTriggerDebounce
    }
  },

  validations() {
    return {
      trigger: {
        configuration: {
          match: {
            required
          },
          debounceMs: {
            timeValid: timeValidator('debounce', 10)
          },
          lookbackMs: {
            timeValid: timeValidator('lookback', 10)
          }
        }
      }
    }
  },

  watch: {
    '$v.trigger.configuration.$invalid': {
      handler: function() {
        this.$emit('validityUpdated', !this.$v.trigger.configuration.$invalid)
      },
      immediate: true
    }
  }
}
</script>
